<template>
  <div class="row">
    <div class="col-12">
      <PageHeader
        :page="page"
        :has-save="false"
        :has-return="true"
        @onReturn="goBack"
      />

      <div class="row">
        <div class="col-12">
          <section-title
            icon="fas fa-file-alt"
            content="Detalle de Alertas"
            container-class="tag-badge-main-info m-0 mb-3"
          />
        </div>
      </div>

      <div
        v-if="results.length === 0"
        class="col-12 p-4 text-center align-items-center no-info mt-4"
      >
        <div class="row justify-content-center">
          <div class="col-12 col-lg-1 align-self-center">
            <i class="far fa-folder-open icon no-info-icon pl-2" />
          </div>
          <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
            <span class="no-info-text">No hay información disponible.</span>
          </div>
        </div>
      </div>

      <div v-if="results.length !== 0">
        <custom-callout
          v-for="item in results"
          :key="item.$key"
          class="mt-4 mb-4"
          :show-bottom-section="true"
          :border-color="'gray'"
        >
          <div class="row">
            <div class="col-6 col-md-2">
              <span class="body-2 text-gray">Número SIE:</span>
              <p class="body-1 font-weight-normal">
                {{ item.studentSieId }}
              </p>
            </div>

            <div class="col-6 col-md-3">
              <span class="body-2 text-gray">
                Nombre Estudiante:
                <br />
              </span>
              <span class="body-1 font-weight-normal">{{ item.fullName }}</span>
            </div>
            <div class="col-6 col-md-2">
              <span class="body-2 text-gray">
                Tipo Alerta:
                <br />
              </span>
              <span class="body-1 font-weight-normal">
                {{ item.alertType }}
              </span>
            </div>
            <div class="col-6 col-md-3">
              <span class="body-2 text-gray">
                Sub Tipo Alerta:
                <br />
              </span>
              <span class="body-1 font-weight-normal">{{ item.subType }}</span>
            </div>
            <div class="col-6 col-md-2">
              <span class="body-2 text-gray">
                Record Seleccionado:
                <br />
              </span>
              <span class="body-1 font-weight-normal">
                {{ item.recordKey }}
              </span>
            </div>
          </div>
          <template #container_bottom>
            <div class="row">
              <div class="col-6 col-md-9">
                <span class="body-2 text-gray">
                  Alerta:
                  <br />
                </span>
                <span class="body-1 font-weight-normal">
                  {{ item.alertDescription }}
                </span>
              </div>
              <div
                class="col-6 col-md-3 d-flex justify-content-end align-items-center text-right"
              >
                <ActionButton
                  v-if="showVaccinationCertificate"
                  variant="outline-success"
                  text="Certificación de Vacuna"
                  i="fas fa-file-download mx-auto"
                  @click="downloadCertification(item.studentSieId)"
                />
              </div>
            </div>
            <br />
            <div v-if="item.message" class="row">
              <div class="col-6 col-md-9">
                <span class="body-2 text-gray">
                  Mensaje:
                </span>
                <span class="body-1 font-weight-normal">               
                  <div v-html="item.message" />
                </span>
              </div>
            </div>
          </template>
        </custom-callout>

        <customPager
          ref="historyPager"
          :per-page="currentPaging.pageSize"
          :external-current-page="currentPaging.currentPage"
          :total="currentPaging.totalItemCount"
          :page-changed="goToPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import CustomCallout from '@/components/common/CustomCallout.vue';
import PageHeader from '@/components/common/page/PageHeader';
import ActionButton from 'ActionButton';
import alertTypes from '@/utils/constants/alertTypes';
import reportService from '@/services/report';

import { modulesName } from '@/modules';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters } = createNamespacedHelpers(
  modulesName.dashboardModuleName
);

export default {
  name: 'Alert',
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Alerta',
        routes: ['Inicio', 'Alerta'],
      },
      alertTypeId: this.$route.params.id,
    };
  },
  components: {
    SectionTitle,
    CustomCallout,
    PageHeader,
    ActionButton,
  },
  computed: {
    ...mapGetters({
      results: 'getAlertsDetails',
      currentPaging: 'getPaging',
    }),
    showVaccinationCertificate() {
      return this.alertTypeId == alertTypes.VaccinationEligible;
    },
  },
  methods: {
    ...mapActions({
      getAlertsDetails: 'getAlertsDetails',
    }),
    getAlerts() {
      this.getAlertsDetails({
        alertTypeId: this.$route.params.id,
        pageSize: this.currentPaging.pageSize,
        pageIndex: 1,
      });
    },
    goToPage(page) {
      this.getAlertsDetails({
        alertTypeId: this.$route.params.id,
        pageSize: this.currentPaging.pageSize,
        pageIndex: page.currentPage,
      });
    },
    goBack() {
      this.$router.back();
    },
    async downloadCertification(studentSieId) {
      await reportService.downloadVaccinationCertification(studentSieId);
    },
  },
  async mounted() {
    this.getAlerts();
  },
};
</script>

<style scoped></style>
